import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { GlobalService } from '../services/global.service';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.page.html',
  styleUrls: ['./admin.page.scss'],
})
export class AdminPage implements OnInit {

  usersList = "";

  constructor(private router:Router,private apiService:ApiService,private globalService:GlobalService,private alertController: AlertController) { }

  ngOnInit() {

    try {
      this.getUserFun();
      // console.log("UUUUUUUUUUUUUUser", users);
      // localStorage.setItem('usersList', JSON.stringify(users));
  } catch (error) {
      console.error('Error fetching users:', error);
  }
  }

  getUserFun() {
    // const lang = localStorage.getItem('language');
    // const cate = localStorage.getItem('textCategory');
   //  console.log("Cate on LOcalstorea is:",cate)
    this.apiService.getUser().subscribe(
     (response) => {
       this.usersList = response;
      localStorage.setItem('usersList', JSON.stringify(this.usersList));

      // console.log("RRRRRRRRRRRRRRR",this.usersList)


       
       // this.textItems = [
       //   {
       //     "TextId": "1",
       //     "Text": "A",
       //     "Language": "nl",
       //     "DateCreated": "2024-08-01 10:11:00",
       //     "DateModified": null
       //   },
       //   {
       //     "TextId": "2",
       //     "Text": "B",
       //     "Language": "nl",
       //     "DateCreated": "2024-08-01 10:11:00",
       //     "DateModified": null
       //   },
       //   {
       //     "TextId": "3",
       //     "Text": "C",
       //     "Language": "nl",
       //     "DateCreated": "2024-08-01 10:11:00",
       //     "DateModified": null
       //   }
       // ]
      //  this.textItems = response;
      //  console.log("response is:",response);
       // this.textFromServer = response.Text;
       // this.idOfTextFromServer = response.TextId;
       // console.log("textFromServer",this.textFromServer);

      //  this.displayCurrentItem();
      return response
     },
     (err) => {
       console.log(err);
     }
   );
 }


  goToMenu() {
    this.router.navigate(['/menu']);
  }

  goToAllHistory(){
    this.router.navigate(['/allhistory']);
  }

  async confirmLogout() {
    // if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        // this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      // }else{
      //   await this.LogoutFunction();
      // }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');
          localStorage.removeItem('userRole');

          // this.stopPlayingSound();
          // this.endClick = false;
          // this.pauseClick = false;
          // this.audioChunks = [];
          // this.recordedAudioUrl = '';
          // this.textFromServer = "";

          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);    
      }catch(error){
        console.log("Error:", error);
        // this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
      
  };


}
